import React, { useEffect, useState } from "react";
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    P404,
    C_CONNECTION_OVERVIEW,
    C_CONNECTION_NOTES,
    C_CONNECTION_ATTACHMENTS,
    C_CONNECTION_TASKS,
    C_CONNECTION_LOGS,
    REGISTRY,
    C_CONNECTION_ADDRESSES,
    C_CONNECTION_CONDITIONS
} from "../endpoints";
import {getPathParam} from "../../utils/converter";
import {getPermission, permissionGroup, permissionSpecific, permissionType} from "../../constants/permissions";
import {COMPANY, CUSTOMER} from "../../api/endpoints";
import {fetchCountries, fetchCurrencies, fetchLanguages} from "../../reducers/configReducer";
import BasePermissionWrapper, {hasPermissionFor} from "../../components/partials/restricted/base-permission-wrapper";
import LoaderWrapper from "../../components/common/loader/loader-wrapper";
import {ConnectionHeaderNavigation, ConnectionPanelNavigation} from "../../components/partials/panel/connection-panel-navigation";
import GenericEmailSender from "../../components/partials/email/generic-email-sender";
import {loadCustomers} from "../../reducers/connectionReducer";
import {getCustomer} from "../../api/customer";
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const CustomerOverview = () => {
  const { loggedCompany } = useSelector((state) => state.user);
  const { t } = useTranslation();
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { pathname } = location;

  // get customer
  const [isLoading, setLoading] = useState(true);
  const [connection, setConnection] = useState({});
  const [typeActive, setTypeActive] = useState(null);

  const { permissions } = useSelector((s) => s.userCompany);

  const canEdit =  hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionType.EDIT);
  const canSendMail = hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionSpecific.CUSTOMER_SEND_MAIL);
  const canViewBi = hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionSpecific.CUSTOMER_BI);


  // update customer
  const [isSidebarOpen, setOpenSidebar] = useState(false);

  // update customer
  const [isOpenEmailSender, setOpenEmailSender] = useState(false);


  const fetchConnection = (signal = null, loading = true) => {
      if (loggedCompany) {
          setLoading(loading);
          getCustomer({ company_id: loggedCompany.id, customer_id: id, signal })
              .then((response) => {
                  setConnection(response);
                  setLoading(false);
              })
              .catch((e) => {
                  setLoading(false);
                  e.code === 404 && navigate(P404);
              });
      }
  }

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;


      fetchConnection(signal);

    dispatch(fetchCountries());
    dispatch(fetchCurrencies());
    dispatch(fetchLanguages());

    return () => {
      controller.abort();
    };
      // eslint-disable-next-line
  }, [id, loggedCompany, dispatch]);

    const secondaryNavigation = [
        canViewBi && { name: t("app.leads.overview"), type: 'overview', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_OVERVIEW]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_OVERVIEW])) },
        canEdit && { name: t("app.connection.addresses"), type: 'addresses', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_ADDRESSES]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_ADDRESSES])) },
        canEdit && { name: t("app.leads.notes"), type: 'note', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_NOTES]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_NOTES])) },
        canEdit && { name: t("app.connection.conditions"), type: 'condition', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_CONDITIONS]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_CONDITIONS])) },

        canEdit && { name: t("app.leads.attachments"), type: 'attach', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_ATTACHMENTS]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_ATTACHMENTS])) },
        { name: t("app.menu.boards"), type: 'task', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_TASKS]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_TASKS])) },
        canEdit && { name: t("app.leads.logs"), type: 'log', location: getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_LOGS]), current: pathname.includes(getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_LOGS])) }
    ].filter(Boolean);


    useEffect(() => {
        if(permissions){
            if(!hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionSpecific.CUSTOMER_BI) && !hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionType.EDIT)){
                navigate("/" + getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_TASKS]));
            }else if(!hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionSpecific.CUSTOMER_BI) && hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionType.EDIT)){
                navigate("/" + getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_NOTES]));
            }else{
                if(hasPermissionFor(permissions, permissionGroup.CUSTOMER, permissionSpecific.CUSTOMER_BI)){
                    navigate("/" + getPathParam([REGISTRY, CUSTOMER, id, C_CONNECTION_OVERVIEW]));
                }
            }
        }
// eslint-disable-next-line
    }, [permissions]);







  return (
      <BasePermissionWrapper
          requiredPermissions={[getPermission(permissionGroup.CUSTOMER, permissionType.VIEW)]}
      >

        <LoaderWrapper isLoading={isLoading}>



          <div className="flex h-full">

            <div className="flex min-w-0 flex-1 flex-col overflow-hidden">

              <div className="relative z-0 flex flex-1 overflow-hidden">


                  <main className="relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last">


                  {/* Start main area*/}
                  <div className="absolute inset-0 ">

                      <ConnectionHeaderNavigation canEdit={canEdit} connection={connection} canSendRequest={true} onOpenSidebar={(r) => {setOpenSidebar(r)} } isSidebarOpen={isSidebarOpen} />


                      <div className="bg-white border-b border-gray-200">
                          <nav className=" flex space-x-8 max-w-7xl mx-auto justify-center overflow-x-auto px-4 leading-6   sm:px-6 lg:px-8" aria-label="Tabs">
                              {secondaryNavigation.map((tab) => (
                                  <Link
                                      key={tab.name}
                                      to={'/'+tab.location}
                                      className={classNames(
                                          tab.current
                                              ? 'border-sky-400 text-blue-1000'
                                              : 'border-transparent text-blue-1000/[0.5] hover:text-blue-1000 hover:border-sky-400',
                                          'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-xs uppercase'
                                      )}
                                  >
                                      {tab.name}
                                  </Link>
                              ))}
                          </nav>
                      </div>

                      <Outlet
                          context={{
                              connectionId: connection.id,
                              entityId: connection.id,
                              overviewData: connection,
                              typeActive: typeActive,
                              canEdit: canEdit,
                              removeActive: () => {
                                  setTypeActive(null);
                              },
                              onUpdateData: (r) => {
                                  setConnection(r);
                              },
                              onRefresh: (r) => {
                                  fetchConnection(null, false);
                              }
                          }}
                      />



                  </div>
                  {/* End main area */}
                </main>


                  <ConnectionPanelNavigation
                      connection={connection}
                      canEdit={canEdit}
                      onOpenSidebar={(r) => {setOpenSidebar(r)} }
                      isSidebarOpen={isSidebarOpen}
                      canSendRequest={true}
                      onCreate={(r) => {
                          if(r === 'mail'){
                              setOpenEmailSender(true);
                          }else{
                              setTypeActive(r);
                              navigate("/"+secondaryNavigation.find(n => n.type === r).location);
                          }
                      }}
                      onResponse={(response) => {
                          setConnection(response);
                          dispatch(loadCustomers(loggedCompany.id));
                      }}
                      detailGroups={[
                          {
                              endpoint: getPathParam([COMPANY, loggedCompany?.id ?? '', CUSTOMER, connection?.id ?? '' ]),
                              isCreate: false,
                              refId: connection?.id ?? '' ,
                              defaultOpen: true,
                              title: t("app.customers.customer_info"),
                              fields: [
                                  {field: 'business_name', translation: 'app.customers.business_name',   value: connection?.business_name ?? '-',  viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_reference', translation: 'app.customers.reference',   value: connection?.importer_reference ?? '-',  viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_address', translation: 'app.customers.importer_address',  value: connection?.importer_address ?? '-', viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_city', translation: 'app.customers.importer_city',  value: connection?.importer_city ?? '-', viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_zip_code', translation: 'app.customers.importer_zip_code',  value: connection?.importer_zip_code ?? '-', viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_country', translation: 'app.form.country',  value: connection?.importer_country?.name ?? '-', object: connection?.importer_country ?? null, viewType: 'string', formType: 'country', required: false},
                                  {field: 'importer_email', translation: 'app.customers.importer_email',  value: connection?.importer_email ?? '-', viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_vat_code', translation: 'app.customers.vat_code',  value: connection?.importer_vat_code ?? '-', viewType: 'string', formType: 'string', required: false},
                                  {field: 'importer_last_contact', translation: 'app.leads.last_contact_date',  value: connection?.importer_last_contact ?? null, viewType: 'date', formType: 'date', required: false}
                              ]
                          },
                          {
                              endpoint: getPathParam([COMPANY, loggedCompany?.id ?? '', CUSTOMER, connection?.id ?? '' ]),
                              isCreate: false,
                              refId: connection?.id ?? '' ,
                              defaultOpen: false,
                              title: t("app.customers.company_info"),
                              fields: [
                                  {field: 'importer_currency', translation: 'app.quotations.currency',   value: connection?.importer_currency?.code ?? '-', object: connection?.importer_currency ?? null,  viewType: 'string', formType: 'currencies', required: true},
                                  {field: 'importer_language', translation: 'app.common.language',  value: connection?.importer_language?.name ?? '-', object: connection?.importer_language ?? null, viewType: 'string', formType: 'languages', required: true},
                                  {field: 'payment_terms', translation: 'app.quotations.payment_terms',  value: connection?.payment_terms ?? '-', viewType: 'editor', formType: 'editor', required: true}
                              ]
                          }
                      ]}
                  />
              </div>
            </div>
          </div>

            {
                canSendMail && (
                    <GenericEmailSender
                        isOpen={isOpenEmailSender}
                        baseTitle={t("app.leads.lead")}
                        entityType={'connection'}
                        entityNote={'lead'}
                        entityId={connection?.id ?? ''}
                        baseEmail={[{
                            id: 1,
                            full_name: connection?.business_name ?? '',
                            email: connection?.importer_email
                        }]}
                        baseAttachments={connection?.last_connection_attachment ?? []}
                        setIsOpen={(r) => {
                            setOpenEmailSender(r);
                        }}
                    />
                )
            }



        </LoaderWrapper>

      </BasePermissionWrapper>
  );
};

export default CustomerOverview;
